<script setup lang="ts">
const router = useRouter();

definePage({
  meta: {
    navActiveLink: "profile",
  },
});

onMounted(() => {
  router.replace({ path: "/profile" });
});
</script>

<template>
  <div class="pa-6 text-body-2 text-medium-emphasis">
    Redirecting...
  </div>
</template>
